var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.7059C22 14.6297 19.4416 17 16.2857 17H12.75V19.1454C13.2513 19.3483 13.6517 19.7486 13.8546 20.25H22C22.4142 20.25 22.75 20.5858 22.75 21C22.75 21.4142 22.4142 21.75 22 21.75H13.8546C13.5579 22.483 12.8393 23 12 23C11.1607 23 10.4421 22.483 10.1454 21.75H2C1.58579 21.75 1.25 21.4142 1.25 21C1.25 20.5858 1.58579 20.25 2 20.25H10.1454C10.3483 19.7486 10.7487 19.3483 11.25 19.1454V17H6.28571C3.91878 17 2 15.2223 2 13.0294C2 10.8365 3.91878 9.05882 6.28571 9.05882C6.56983 9.05882 6.8475 9.08444 7.11616 9.13331C6.88706 8.56043 6.7619 7.94082 6.7619 7.29412C6.7619 4.37026 9.32028 2 12.4762 2C15.4159 2 17.8371 4.0566 18.1551 6.70154C20.393 7.41897 22 9.38856 22 11.7059Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkCloud);
export default __webpack_public_path__ + "static/media/network-cloud.a40cb3543c9c2f210ea4dbb35697446d.svg";
export { ForwardRef as ReactComponent };